import { render, staticRenderFns } from "./loading-page.vue?vue&type=template&id=9e327426&"
import script from "./loading-page.vue?vue&type=script&lang=js&"
export * from "./loading-page.vue?vue&type=script&lang=js&"
import style0 from "./loading-page.vue?vue&type=style&index=0&id=9e327426&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports